import request from '../../../utils/request';

export type FieldKey = 'licensable' | 'product' | 'version' | 'edition' | 'metric' | 'publisher';

export interface ISnAiReviewStatus {
  value: number;
  name: string;
  safe_to_reset: boolean;
}

export interface ISnAiSuggestion {
  id: number;
  software_normalization_id: number;
  suggested_licensable: string | null;
  suggested_product: string | null;
  suggested_version: string | null;
  suggested_edition: string | null;
  suggested_metric: string | null;
  suggested_publisher: string | null;
  confidence: 'High' | 'Medium' | 'Low';
  ai_reasoning: string | null;
  status: string;
  created_at: string;
  software_normalization: {
    id: number;
    software_title: string;
    licensable: string | null;
    product: string | null;
    version: string | null;
    edition: string | null;
    metric: string | null;
    publisher: string | null;
  };
}

export interface IReviewQueueResponse {
  data: ISnAiSuggestion[];
  count: number;
  page: number;
  limit: number;
}

const BASE = '/cmdb-sn-ai-review';

class SnAiReviewService {
  async getQueue(page: number, limit: number): Promise<IReviewQueueResponse> {
    const res = await request({ url: `${BASE}/review?page=${page}&limit=${limit}`, method: 'GET' });
    return res.data.body.data;
  }

  async getCount(): Promise<number> {
    const res = await request({ url: `${BASE}/review/count`, method: 'GET' });
    return res.data.body.data.count;
  }

  async acceptField(id: number, field: FieldKey): Promise<void> {
    await request({ url: `${BASE}/review/${id}/accept-field`, method: 'POST', data: { field } });
  }

  async acceptAll(id: number): Promise<void> {
    await request({ url: `${BASE}/review/${id}/accept-all`, method: 'POST' });
  }

  async rejectField(id: number, rejection_reason: string | undefined, feed_to_learning: boolean): Promise<void> {
    await request({ url: `${BASE}/review/${id}/reject-field`, method: 'POST', data: { rejection_reason, feed_to_learning } });
  }

  async skip(id: number): Promise<void> {
    await request({ url: `${BASE}/review/${id}/skip`, method: 'POST' });
  }

  async triggerBatch(): Promise<{ processed: number | null; started?: boolean; batch_size?: number; message?: string }> {
    const res = await request({ url: `${BASE}/process`, method: 'POST' });
    return res.data.body.data;
  }

  async getStatuses(): Promise<ISnAiReviewStatus[]> {
    const res = await request({ url: `${BASE}/statuses`, method: 'GET' });
    return res.data.body.data;
  }
}

export default new SnAiReviewService();
